/* eslint-disable react/prop-types */
import React from 'react'
import { Route } from 'react-router-dom'

import HomeLayout from 'Layouts/home'

function PublicRoute({
  component: Component,
  layout: Layout = HomeLayout,
  ...rest
}) {
  return (
    <Route>
      <Layout>
        <Component {...rest} />
      </Layout>
    </Route>
  )
}

export default PublicRoute
